import { postRequest, patchRequest } from '@helpers/request'
import { logger } from '@helpers/logger'
import { convertToLocalTime } from '@helpers/convertToLocalTime'

// Function to post tournament pool data
export const postTournamentPool = async (tournamentData) => {
  const data = { tournamentData } // Use data instead of params
  try {
    const { response, logComplete } = await postRequest('tournamentPool', data) // Call the postRequest helper function

    logger.log('postTournamentPool response:', response) // Log the full response for debugging

    // Check if userTournamentPoolEntryEvents exists and is an object
    if (response.userTournamentEntry.userEntry.userTournamentPoolEntryEvents) {
      // Map over the keys of the object
      const updatedEvents = Object.keys(response.userTournamentEntry.userEntry.userTournamentPoolEntryEvents).map((key) => {
        const event = response.userTournamentEntry.userEntry.userTournamentPoolEntryEvents[key]
        const { eventDateLocal, eventTimeLocal } = convertToLocalTime(event.dateEvent, event.strTime)
        return { ...event, eventDateLocal, eventTimeLocal }
      })

      // Sort the updated events based on date and time
      updatedEvents.sort((a, b) => new Date(a.dateEvent + 'T' + a.strTime) - new Date(b.dateEvent + 'T' + b.strTime))

      // Assign the updated events back to the response
      response.userTournamentEntry.userEntry.userTournamentPoolEntryEvents = updatedEvents

      logComplete() // Call the completion logging function
      return response.userTournamentEntry // Return the updated userTournamentEntry
    }
  } catch (error) {
    logger.error('postTournamentPool', error) // Log the error
  }
}

export const patchTournamentPool = async (tournamentKey, updates) => {
  const data = { tournamentKey, updates }
  try {
    const { response, logComplete } = await patchRequest('tournamentPool', data)

    response.userTournamentEntry.userEntry.userTournamentPoolEntryEvents = Object.keys(response.userTournamentEntry.userEntry.userTournamentPoolEntryEvents)
      .map((key) => {
        const event = response.userTournamentEntry.userEntry.userTournamentPoolEntryEvents[key] // Access the event using the key
        const { eventDateLocal, eventTimeLocal } = convertToLocalTime(event.dateEvent, event.strTime)
        return { ...event, eventDateLocal, eventTimeLocal }
      })
      .sort((a, b) => new Date(a.dateEvent + 'T' + a.strTime) - new Date(b.dateEvent + 'T' + b.strTime))

    logComplete() // Call the completion logging function
    return response.userTournamentEntry
  } catch (error) {
    logger.error('patchTournamentPool', error)
  }
}
